<div class="points-list">
  <div *ngFor="let pack of pointsPackages" class="points-card" [class.popular]="pack.popular">
    <div class="most-popular" *ngIf="pack.popular">Most Popular</div>
    <div class="icon">
      <img src="../../../../assets/images/coin.png" alt="Coins">
    </div>
    <h3>{{ pack.title }}</h3>
    <p class="price" *ngIf="!pack.isCustom">{{ pack.price }}</p>

    <!-- Если Custom, отображаем input, иначе число -->
    <p class="points" *ngIf="!pack.isCustom">
      Game Points <br>
      <span >{{ pack.points | number }}</span>
    </p>

    <div class="custom-input-container" *ngIf="pack.isCustom">
      <span class="dollar-sign">$</span>
      <input
        type="number"
        [(ngModel)]="customAmount"
        (input)="validateInput()"
        placeholder="0.00"
        min="0"
        step="0.01"
      />
    </div>

    <p *ngIf="pack.isCustom" class="custom-input-subtitle">1 Point = $0.01</p>

    <button class="purchase-btn btn" [disabled]="pack.isCustom && customAmount <= 0" (click)="redirectToPayment(pack)">
      Purchase
    </button>
  </div>
</div>

<app-modal
  [isOpen]="isModalOpen"
  [icon]="'assets/images/coin.png'"
  [title]="'Points Added!'"
  [text]="'Congratulations! You’ve earned'"
  [primaryBtnText]="'Purchase Points'"
  (primaryClick)="closeModal()"
  (close)="closeModal()"
>
  <div class="points-info">
    <p class="earned-points"><img src="../../../../assets/images/coin.png" alt="Coins"> <span>+{{ pointsEarned }}</span></p>
    <div class="balance-box">
      <p>New Balance: <span>{{ userBalance() | number }}</span></p>
    </div>
  </div>
</app-modal>

